import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Accordion, AccordionSummary, AccordionDetails } from '@interstate/components/AccordionGroup';
import { Typography } from '@interstate/components/Typography';
import { BusinessInformationFields } from './BusinessInformationFields';
import { BankInformation } from './BankInformation';
import { useCustomerCardContext } from '../CustomerCardProvider';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as customerSpdSelectors from '@makemydeal/dr-dash-store/selectors/customerSpdSelectors';

export const BusinessInformation = () => {
    const { hasBusinessData } = useCustomerCardContext();
    const commonConsumerId = useSelector(offerReduxSelectors.getShopperCommonConsumerId);
    const checkSpdData = useSelector(customerSpdSelectors.getCheckCustomerSpdResult(commonConsumerId));
    const [expanded, setExpanded] = useState(hasBusinessData || !!checkSpdData?.bankAccountNumber);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleChange} data-testid="business-information-accordion">
            <AccordionSummary chevronPosition="left">
                <Typography
                    variant="anchor-block-md"
                    color="base.color.blue.700"
                    data-testid="business-information-accordion-header"
                    sx={{ textWrap: 'auto' }}
                >
                    Business Information
                </Typography>
            </AccordionSummary>
            <AccordionDetails data-testid="business-information-accordion-content">
                <BusinessInformationFields />
                <BankInformation />
            </AccordionDetails>
        </Accordion>
    );
};
